import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export interface AppState {
  /** Currently active workspace id (selected in TopBar). */
  activeWorkspaceId: string | null;
  /** Whether the right rail (Co-pilot panel) is collapsed. */
  railCollapsed: boolean;
  /** Whether the left nav (workspace navigation) is collapsed. */
  navCollapsed: boolean;
  /** Pending message draft to seed into the XAMI input (consumed once). */
  railDraft: string | null;
  setActiveWorkspaceId: (id: string | null) => void;
  toggleRail: () => void;
  setRailCollapsed: (collapsed: boolean) => void;
  toggleNav: () => void;
  setNavCollapsed: (collapsed: boolean) => void;
  primeRailMessage: (draft: string) => void;
  consumeRailDraft: () => string | null;
}

export const useAppStore = create<AppState>()(
  persist(
    (set, get) => ({
      activeWorkspaceId: null,
      railCollapsed: false,
      navCollapsed: false,
      railDraft: null,
      setActiveWorkspaceId: (id) => set({ activeWorkspaceId: id }),
      toggleRail: () => set((s) => ({ railCollapsed: !s.railCollapsed })),
      setRailCollapsed: (collapsed) => set({ railCollapsed: collapsed }),
      toggleNav: () => set((s) => ({ navCollapsed: !s.navCollapsed })),
      setNavCollapsed: (collapsed) => set({ navCollapsed: collapsed }),
      primeRailMessage: (draft) =>
        set({ railDraft: draft, railCollapsed: false }),
      consumeRailDraft: () => {
        const v = get().railDraft;
        if (v != null) set({ railDraft: null });
        return v;
      },
    }),
    {
      name: "workforceos.appstore",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({
        activeWorkspaceId: s.activeWorkspaceId,
        railCollapsed: s.railCollapsed,
        navCollapsed: s.navCollapsed,
      }),
    },
  ),
);
